var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotificationsOff = function SvgNotificationsOff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.59 15c-.06.16-.09.32-.09.5 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.18-.04-.34-.09-.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.08 10.97c-.05-.17-.08-.36-.08-.56v-3.4c0-2.76-2.36-5-5-5-1.06 0-2.07.37-2.9.98zM4.38 5.15C4.14 5.73 4 6.35 4 7v3.4c0 .9-.5 1.5-1.09 1.85-.4.24-.91.57-.91.97 0 .46.29.77.89.77h10.33z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m1 1 16 16"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotificationsOff);
export { ForwardRef as Icon };
export default "img/element-icons/roomlist/notifications-off.47f2c41.svg";